var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHangers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "hangers_svg__a",
  d: "M0 0h26v15H0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7 11)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "hangers_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hangers_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M1.632 14.005h22.79",
  mask: "url(#hangers_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20 15.809v-1.263c.709-.104 1.257-.744 1.257-1.515 0-.844-.655-1.531-1.46-1.531-.744 0-1.358.588-1.446 1.344M25.824 20.412c-2.043-.874-3.131-2.35-3.131-2.35C21.616 15.873 20 15.873 20 15.873H20s-1.616 0-2.693 2.19c0 0-1.087 1.475-3.13 2.35-4.21 1.8-7.642 2.026-6.43 4.921L20 19.858l12.253 5.476c1.21-2.895-2.223-3.122-6.43-4.922Z"
}))));
export default SvgHangers;